import React, { PureComponent } from "react";
import R from "ramda";
import { observer } from "mobx-react";
import { withState } from "recompose";

import { mapPath } from "../reusable/utils";
import { Fill } from "../reusable/layout";
import blockStore, {
  selectBlock,
  addBlock,
  updateProperties,
  updateCanvasSize
} from "../canvas/store";
import { linkedBlocks } from "../spreadsheet/store";
import Canvas from "../canvas/index";
import { state } from "./index";

class Resizer extends PureComponent {
  componentDidMount() {
    this.updateInnerSize(this.props.streamWidth, this.props.streamHeight);
    window.onresize = () => {
      this.updateInnerSize(this.props.streamWidth, this.props.streamHeight);
    };
  }

  updateInnerSize = (sW, sH) => {
    this.props.onNewSize(this.calculateInnerSize(sW, sH));
  };

  componentWillReceiveProps(p) {
    if (p.streamWidth !== this.props.streamWidth || p.streamHeight !== this.props.streamHeight) {
      this.updateInnerSize(p.streamWidth, p.streamHeight);
    }
  }

  calculateInnerSize = (streamWidth, streamHeight) => {
    const destRatio = Math.min(
      this.container.offsetWidth / streamWidth,
      this.container.offsetHeight / streamHeight
    );

    return { width: streamWidth * destRatio, height: streamHeight * destRatio };
  };

  render() {
    const resized = this.props.canvasSize
      ? mapPath(["canvas"], c => R.merge(c, this.props.canvasSize), this.props.blocks)
      : this.props.blocks;
    return (
      <div ref={r => (this.container = r)} style={{ width: "100%", height: "100%" }}>
        {this.props.children(resized)}
      </div>
    );
  }
}

const renderCanvas = (blocks, canvasSize, selected, showOutline, preview) => {
  return (
    <Resizer
      blocks={blocks}
      streamWidth={blocks.canvas.streamWidth}
      streamHeight={blocks.canvas.streamHeight}
      onNewSize={ns => {
        updateCanvasSize(ns);
      }}
      canvasSize={canvasSize}>
      {blocks => (
        <Canvas
          onAddBlockInside={addBlock}
          onSelect={selectBlock}
          selectedBlock={selected}
          blocks={blocks}
          showOutline={showOutline}
          updateProperties={updateProperties}
          editing={!preview}
        />
      )}
    </Resizer>
  );
};

const showExitReminder = hide => {
  return (
    <div id="exitReminder">
      Press the 'Esc' key to leave Preview mode {" "}
      <button onClick={hide}>
        <i className="fa fa-times" />
      </button>
    </div>
  );
};

const enhance = withState("exitReminder", "setExitReminder", true);
export default observer(
  enhance(({ live, exitReminder, setExitReminder }) => {
    return (
      <Fill>
        {renderCanvas(
          linkedBlocks.get(),
          blockStore.canvasSize,
          blockStore.selected,
          blockStore.showOutline,
          live || state.isPreview
        )}
        {!live && state.isPreview && exitReminder && showExitReminder(() => setExitReminder(false))}
      </Fill>
    );
  })
);



// WEBPACK FOOTER //
// ./src/layout/master.js